export const LIST_NOTIFICATION = 'LIST_NOTIFICATION';
export const LIST_NOTIFICATION_SUCCESS = 'LIST_NOTIFICATION_SUCCESS';
export const LIST_NOTIFICATION_ERROR = 'LIST_NOTIFICATION_ERROR';